import { ComponentType, forwardRef } from "react";

interface ObscuredProps {
  children?: React.ReactNode;
  component?: ComponentType<any>;
  [key: string]: any;
}

/**
 * Wrapper component that adds data-openreplay-obscured attribute
 * to hide sensitive data from session recordings.
 * Uses forwardRef so refs (e.g. from react-otp-input) reach the underlying element.
 */
export const ObscuredText = forwardRef<unknown, ObscuredProps>(
  ({ children, component: Component = "span", ...props }, ref) => {
    return (
      <Component {...props} ref={ref} data-openreplay-obscured="">
        {children}
      </Component>
    );
  }
);
ObscuredText.displayName = "ObscuredText";
